import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core';
import { IPSObservabilityService } from '@ips/common-angular';
import { DocumentItemList1 } from 'com.trumbull.phx.document.api-client';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { LoaderComponent } from '../../../loader/loader.component';
import { DocumentProcessingService } from '../../../services/document-processor/document-processor.service';
import { LoaderService } from '../../../services/loader-service/loader.service';
import { OrderDetails } from '../order-details.model';
import { RootObject } from '../orders.model';
import { DocumentReference } from '../record-index-table/record-index-table.component';


@Component({
  selector: 'app-order-details-general-information',
  imports: [PanelModule, CommonModule, LoaderComponent, ButtonModule],
  templateUrl: './order-details-general-information.component.html',
  styleUrl: './order-details-general-information.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailsGeneralInformationComponent implements OnChanges {
  @Input() orderDetails?: OrderDetails;
  @Input() orderData?: RootObject;
  @Input() documents?: (DocumentItemList1 | undefined)[];
  @Output() tableAction = new EventEmitter();

  constructor(
    private readonly loaderService: LoaderService,
    private readonly documentProcessor: DocumentProcessingService,
    @Optional() private readonly observability: IPSObservabilityService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documents']) {
      const documentPattern = /^Claim System - Order Documents$/;
      if (this.documents && this.documents.length > 0 && this.orderDetails) {
        const processedDocs = this.documentProcessor.filterDocumentReferences(this.documents || [], documentPattern);

        // FIXME: See if you can line this up with the document processor matchRequestsToDocuments
        this.orderDetails.attachmentInfo = processedDocs.processedDocs.flatMap(doc => {
          return doc?.lists?.flatMap(list => {
            const matchingItems = doc?.documentItems?.filter(item => 
              item.documentListId === list.id
            ) || [];
        
            return matchingItems.map(item => ({
              fileName: item.displayName,
              documentListId: list.id,
              documentId: item.id,
              documentItems: [item],
              description: item.description
            }));
          }) ?? [];
        }) as DocumentReference[];

        this.observability?.trackEvent('document:processing:generalInfo:attachments:mapped', {
          totalDocumentLists: processedDocs.processedDocs.length,
          totalAttachments: this.orderDetails.attachmentInfo.length,
        });

        this.observability?.trackEvent('document:processing:generalInfo:filter:results', processedDocs.stats);
      }
    }
  }

  downloadFile(file: DocumentReference) {
    this.tableAction.emit({ action: 'downloadSingleFile', data: file });
  }

  keepOriginalSorting = () => 0;

  trackByKey(index: number, item: any): string {
    return item.key;
  }
  
}
